import { Gift, MessageCircle, Phone, Award } from "lucide-react";
import { WHATSAPP_URL, TEL_URL, CONTACT } from "../data/site";

// Professional gift certificate style coupon
export default function CTA() {
    return (
        <section
            data-testid="cta-section"
            className="section bg-[#0a0a0c] relative overflow-hidden"
        >
            <div className="absolute top-0 left-1/4 w-[500px] h-[500px] rounded-full bg-[#c9a24b]/8 blur-[140px] pointer-events-none" />

            <div className="container-x relative">
                <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
                    {/* LEFT — text */}
                    <div className="lg:col-span-6">
                        <div className="eyebrow mb-4">Hoşgeldin Hediyesi</div>
                        <h2 className="h2 text-[#f4efe4]">
                            İlk Randevunuza{" "}
                            <span className="gold-text">Özel %15 İndirim</span>
                        </h2>
                        <div className="divider-gold mt-6" />
                        <p className="mt-6 body-base max-w-xl">
                            WhatsApp üzerinden alacağınız ilk online
                            randevunuzda tüm masaj hizmetlerimizde geçerli
                            olmak üzere %15 indirim otomatik uygulanır. Kupon
                            kodunu belirtmeniz yeterli.
                        </p>

                        <ul className="mt-6 space-y-2.5 text-[14px] text-[#c9c2b3]">
                            {[
                                "Tüm hizmetlerimizde geçerlidir",
                                "İlk ziyaretinize özel",
                                "İptal edilebilir, kısıtlama yoktur",
                                "WhatsApp ile 60 saniyede randevu",
                            ].map((t) => (
                                <li
                                    key={t}
                                    className="flex items-center gap-3"
                                >
                                    <span className="w-1.5 h-1.5 rounded-full bg-gradient-to-br from-[#f5d685] to-[#8a6a28]" />
                                    {t}
                                </li>
                            ))}
                        </ul>

                        <div className="mt-8 flex flex-wrap gap-3">
                            <a
                                href={WHATSAPP_URL}
                                target="_blank"
                                rel="noreferrer"
                                data-testid="cta-whatsapp"
                                className="btn btn-gold"
                            >
                                <MessageCircle className="w-4 h-4" />
                                WhatsApp'tan Randevu Al
                            </a>
                            <a
                                href={TEL_URL}
                                data-testid="cta-call"
                                className="btn btn-ghost"
                            >
                                <Phone className="w-4 h-4" />
                                {CONTACT.phone}
                            </a>
                        </div>
                    </div>

                    {/* RIGHT — professional gift certificate */}
                    <div className="lg:col-span-6 flex justify-center">
                        <div className="relative w-full max-w-md">
                            {/* Ambient gold glow */}
                            <div className="absolute -inset-4 rounded-[32px] bg-gradient-to-br from-[#c9a24b]/40 via-transparent to-[#8a6a28]/30 blur-2xl -z-10" />

                            {/* Certificate card */}
                            <div className="relative bg-gradient-to-br from-[#1a1a20] via-[#141418] to-[#0f0f13] rounded-2xl border border-[#c9a24b]/50 overflow-hidden">
                                {/* Perforated ticket notches (left/right) */}
                                <div className="absolute top-1/2 -translate-y-1/2 -left-3 w-6 h-6 rounded-full bg-[#0a0a0c] border border-[#c9a24b]/40" />
                                <div className="absolute top-1/2 -translate-y-1/2 -right-3 w-6 h-6 rounded-full bg-[#0a0a0c] border border-[#c9a24b]/40" />

                                {/* Header band */}
                                <div className="relative px-6 pt-6 pb-4 border-b border-dashed border-[#c9a24b]/25">
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-2.5">
                                            <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#f5d685] to-[#8a6a28] flex items-center justify-center shrink-0">
                                                <Gift className="w-4 h-4 text-[#0a0a0c]" />
                                            </div>
                                            <div>
                                                <div className="text-[10px] uppercase tracking-[0.28em] text-[#7d766a]">
                                                    Cegu Masaj · Bursa
                                                </div>
                                                <div className="text-[13px] font-semibold gold-text">
                                                    Hediye Sertifikası
                                                </div>
                                            </div>
                                        </div>
                                        <div className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full border border-[#c9a24b]/40 text-[9.5px] uppercase tracking-[0.18em] text-[#c9a24b]">
                                            <Award className="w-3 h-3" />
                                            VIP
                                        </div>
                                    </div>
                                </div>

                                {/* Value */}
                                <div className="px-6 py-8 text-center relative">
                                    {/* Watermark */}
                                    <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none">
                                        <span className="font-bold text-[9rem] leading-none text-[#c9a24b]/[0.04]">
                                            15
                                        </span>
                                    </div>

                                    <div className="relative">
                                        <div className="text-[10.5px] uppercase tracking-[0.32em] text-[#7d766a] mb-2">
                                            İlk Randevu Hediyesi
                                        </div>
                                        <div className="flex items-baseline justify-center gap-1">
                                            <span className="text-[5rem] leading-none font-bold gold-text">
                                                15
                                            </span>
                                            <span className="text-4xl font-semibold gold-text">
                                                %
                                            </span>
                                        </div>
                                        <div className="mt-2 text-[15px] font-semibold text-[#f4efe4] tracking-wide">
                                            İNDİRİM
                                        </div>
                                        <div className="mt-1 text-[12px] text-[#b8b1a1]">
                                            Tüm masaj hizmetlerinde geçerli
                                        </div>
                                    </div>
                                </div>

                                {/* Code + serial */}
                                <div className="px-6 pb-4">
                                    <div className="grid grid-cols-5 gap-3 items-center bg-[#0a0a0c]/60 border border-[#c9a24b]/25 rounded-lg py-3 px-4">
                                        <div className="col-span-3">
                                            <div className="text-[9.5px] uppercase tracking-[0.24em] text-[#7d766a] mb-1">
                                                Kupon Kodu
                                            </div>
                                            <div
                                                className="text-lg font-bold tracking-[0.32em] gold-text"
                                                data-testid="coupon-code"
                                            >
                                                CEGU15
                                            </div>
                                        </div>
                                        <div className="col-span-2 text-right border-l border-[#23232b] pl-3">
                                            <div className="text-[9.5px] uppercase tracking-[0.24em] text-[#7d766a] mb-1">
                                                Seri
                                            </div>
                                            <div className="text-[13px] font-medium text-[#c9c2b3] tabular-nums">
                                                #CGU-2026
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Footer band */}
                                <div className="px-6 py-3 border-t border-dashed border-[#c9a24b]/25 flex items-center justify-between text-[10px] text-[#7d766a]">
                                    <span className="uppercase tracking-[0.22em]">
                                        Cegu Wellness
                                    </span>
                                    <span>Batı Palas · Özlüce</span>
                                </div>

                                {/* Subtle diagonal shine */}
                                <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-white/[0.02] via-transparent to-transparent" />
                            </div>

                            {/* Below-card note */}
                            <div className="mt-4 text-center text-[11px] text-[#7d766a]">
                                * Sertifika, randevu esnasında sunulmalıdır.
                                Diğer indirimlerle birleştirilemez.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
